<template>
  <div class="create-or-change-password flex">  
      <div>
        <v-form ref="passwordRef">
            <label class="--font" v-if="$route.name === 'changePassword'">Current password</label>
            <v-text-field
                v-model="oldPassword"
                :rules="appliedRules"
                v-if="$route.name === 'changePassword'"
                :type="showCurrentPassword ? 'text' : 'password'"
                :append-icon="showCurrentPassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                @click:append="showCurrentPassword = !showCurrentPassword"
                class="password-input" 
                outlined
                placeholder="Enter your current password"/>

            <label class="--font">New password</label>
            <v-text-field
                v-model="newPassword"
                :rules="appliedRules"
                :type="showNewPassword ? 'text' : 'password'"
                class="password-input" 
                :append-icon="showNewPassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                @click:append="showNewPassword = !showNewPassword"
                outlined
                placeholder="Enter your New password"/>

            <label class="--font">Confirm new password</label>
            <v-text-field
                v-model="confirmPassword"
                :rules="appliedRules"
                :type="showConfirmPassword ? 'text' : 'password'"
                class="password-input" 
                :append-icon="showConfirmPassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                @click:append="showConfirmPassword = !showConfirmPassword"
                outlined
                placeholder="Confirm your New password"/>
        </v-form>
      </div>
      <div class="buttons-section">
          <button :disabled="disableOrEnableButton" class="green-background --weight" @click="setOrCreatePassword" v-ripple>Save Changes</button>
      </div>
  </div>
</template>

<script>
import accessToken from '../../../helpers/accessToken';
import rules from '../../../helpers/rules';
import API_URL from '../../../helpers/apiUrls';
export default {
  name: "changeOrCreatePassword",
  data() {
    return {
        showCurrentPassword : false,
        showNewPassword : false,
        showConfirmPassword : false,

        rules : rules,
        appliedRules : [],

        oldPassword : '',
        newPassword : '',
        confirmPassword : ''
    }
  },

  computed : {
      disableOrEnableButton() {
          if(this.$route.name === "createPassword") {
              if(this.newPassword && this.confirmPassword)
                return false;
          }
          else {
              if(this.oldPassword && this.newPassword && this.confirmPassword)
                return false;
          }
          return true;
      },
  },

  methods : {
      setOrCreatePassword() {
          this.appliedRules.push(this.rules.required);
          if(this.$refs.passwordRef.validate()) {
              this.toggleLoader(true);
              const successHandler = response => {
                  if(response.data.status)
                    this.showToast(successMessage);
                  this.toggleLoader(false);
                  this.resetState();
              }

              const errorHandler = error => {
                  this.showToast("Something went wrong internally!", "error", 10000);
                  console.log(error);
                  this.toggleLoader(false);

                  
              }

              const headers = {
                  'Authorization' : `Bearer ${accessToken.getAccessToken()}`,
                  'BRAND-ID' : localStorage.getItem('Brand-ID') 
              } 

              let data = {}
              let endpoint = '';
              let successMessage = '';
              if(this.$route.name === "createPassword") {
                  data = {
                      password : this.newPassword,
                      confirm_password : this.confirmPassword
                  }
                  endpoint = API_URL.createPassword
                  successMessage = 'Your password has been successfully created!'
              }
              else {
                  data = {
                      old_password : this.oldPassword,
                      password : this.newPassword,
                      confirm_password : this.confirmPassword
                  }
                  endpoint = API_URL.resetPassword
                  successMessage = 'Your password has been successfully changed!'
              }
              
              this.requestPOST(
                  endpoint,
                  data,
                  headers,
                  successHandler,
                  errorHandler
              )
          }
      },

      resetState() {
          this.showCurrentPassword = false;
          this.showNewPassword = false;
          this.showConfirmPassword = false;
          this.oldPassword = '';
          this.newPassword = '';
          this.confirmPassword = '';
          this.$refs.passwordRef.reset();
      }
  },
}
</script>

<style lang='scss' scoped>
.create-or-change-password {
    background-color: white;
    height: calc(100vh - 250px);
    flex-direction: column;
}

.create-or-change-password > div {
    width: 30%;
}

.password-input {
    margin-top: 10px;
}

button {
    color: white;
    width: 100%;
    height: 50px;
    border-radius: 3px;
    font-size: 1.1rem;
}

button:disabled {
    background-color: #AFB5B2;
}

</style>